import { render, staticRenderFns } from "./instockScan.vue?vue&type=template&id=35814abf&"
import script from "./instockScan.vue?vue&type=script&lang=js&"
export * from "./instockScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports